import { styled } from '@raskrask-dk/rr-components'

export const InfoBox = styled('div', {
    bgc: '$primary300',
    br: '$1',
    color: '$neutral700',
    display: 'flex',
    gap: '$2',
    p: '$2',
})
